import React, { useEffect } from 'react';

const InviteStepModal = ({ isOpen, onOpenInviteFlow, onDismiss }) => {
  // Block Escape key dismissal — require explicit action
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Backdrop — no onClick, cannot dismiss by clicking outside */}
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />

        {/* Modal */}
        <div className="relative bg-white rounded-2xl shadow-xl max-w-sm w-full p-8 text-center">
          {/* Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <svg className="w-9 h-9 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
            </svg>
          </div>

          <h2 className="text-xl font-bold text-gray-900 mb-3">
            Invite Riders to Book
          </h2>
          <p className="text-gray-600 mb-6">
            Share your unique booking link with riders via QR code, a copyable link, or by sending them an email invitation directly from RideHowl.
          </p>

          <div className="space-y-3">
            <button
              onClick={onOpenInviteFlow}
              className="w-full py-3 px-6 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
            >
              Invite Riders to Book
            </button>
            <button
              onClick={onDismiss}
              className="w-full py-2 px-6 text-gray-500 hover:text-gray-700 text-sm font-medium transition-colors"
            >
              Skip for Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteStepModal;
